import React from 'react'


interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading?: boolean,
    loadingText?: string,
    variant?: "" | "is-primary" | "is-link" | "is-light" | "is-danger" | "is-success"
    disableSpinnerMargin?: boolean
}

export default function Button(
    { isLoading, loadingText, type = "button", variant = "is-primary", disableSpinnerMargin, ...props }: ButtonProps) {

    let { className, disabled, ...rest } = props

    return (
        <button
            className={`button ${variant} ${props.className || ""}`}
            type={type}
            disabled={isLoading || disabled}
            {...rest}
        >
            {isLoading
                ? <><div className={`spinner ${disableSpinnerMargin ? '' : "mr-2"}`} />{loadingText}</>
                : props.children
            }
        </button>
    )
}
